export const StubProjectsPageTexts = {
  thisPage: 'This page',
  will: 'will',
  be: 'be',
  readySoon: 'ready soon',

  
};
